import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Button from "@material-ui/core/Button";

const styles = theme => ({
	root: {
		display: "flex"
	},
	menuButton: {
		background: "rgba(249, 249, 249, 0.7)",
		textTransform: "none"
	}
});

const options = ["Standard", "Satellite"];

class SimpleListMenu extends React.Component {
	state = {
		anchorEl: null,
		selectedIndex: 1
	};

	handleClickListItem = event => {
		this.setState({ anchorEl: event.currentTarget });
	};

	handleMenuItemClick = (event, index) => {
		this.setState({ selectedIndex: index, anchorEl: null });
		this.props.response(options[index]);
	};

	handleClose = () => {
		this.setState({ anchorEl: null });
	};
	handleClick = event => {
		this.setState({ anchorEl: event.currentTarget });
	};

	render() {
		const { classes } = this.props;
		const { anchorEl, selectedIndex } = this.state;

		return (
			<div className={classes.root}>
				<Button
					variant="contained"
					aria-owns={anchorEl ? "simple-menu" : undefined}
					aria-haspopup="true"
					onClick={this.handleClick}
					className={classes.menuButton}
				>
					{options[selectedIndex]}
				</Button>
				<Menu
					id="simple-menu"
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={this.handleClose}
				>
					{options.map((option, index) => (
						<MenuItem
							key={option}
							selected={index === this.state.selectedIndex}
							onClick={event => this.handleMenuItemClick(event, index)}
						>
							{option}
						</MenuItem>
					))}
				</Menu>
			</div>
		);
	}
}

SimpleListMenu.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimpleListMenu);
